// '2.24.1' is replaced before publishing to npm at .github/workflows/publish_sdk.yml
export const SDK_VERSION = '2.24.1'
